import cookiesManager from '../utils/cookies';
import { AUTH_KEYS, USER_DATA, USER_DETAILS } from '../utils/cookies/keys';
import { API_ENDPOINTS } from './endpoints';
import { getCmsDataInterface, IEbhRecommender } from './hooks/cms/interface';
import {
  IRefreshToken,
  IRefreshTokenResponse,
  IUserDetailsResponse,
} from './hooks/login-sign-up/interface';
import { devApiGwNoAuth, devApiGwXAuthClient } from './interceptor';
import { RolesApiData } from '../interface/permissions'

export const userLogout = async () => {
  const response = await devApiGwXAuthClient.post(
    API_ENDPOINTS.userLogout,
    {
      loginType: 'HOS',
      username: cookiesManager.get(USER_DETAILS.USERNAME) ?? '',
      token: cookiesManager.get(AUTH_KEYS.REFRESH_TOKEN) ?? '',
    },
    {
      headers: {
        'x-platform': 'web',
        'ocp-apim-subscription-key': import.meta.env.VITE_SUBSCRIPTION_KEY,
      },
    },
  );

  return response.data?.data;
};

export const refreshTokenAuth = async (payload: IRefreshToken) => {
  const ocpApimSubscriptionKey = import.meta.env.VITE_SUBSCRIPTION_KEY;
  const RefreshToken = decodeURIComponent(cookiesManager.get(AUTH_KEYS.REFRESH_TOKEN) ?? "");
  const { data } = await devApiGwNoAuth.post<IRefreshTokenResponse>(
    API_ENDPOINTS.refreshToken,
    {
      ...payload,
      ...(RefreshToken && { token: RefreshToken }),
      ...(payload?.ssoToken && { ssoToken: payload?.ssoToken }),
    },
    {
      headers: {
        'x-platform': 'web',
        'ocp-apim-subscription-key': ocpApimSubscriptionKey,
      },
    },
  );

  return data;
};

export const getEbhRecommender = async (payload: IEbhRecommender) => {
  const grpId = cookiesManager.get(USER_DATA.GROUP_ID);
  const { data } = await devApiGwXAuthClient.get(
    `${API_ENDPOINTS.ebhRecommender}/${payload.collectionType}`,
    {
      headers: {
        source: 'vidal',
        'x-calling-source': 'vidal',
        'x-groupid': grpId,
        ...payload.headers,
      },
      params: {
        pageType: payload.pageType,
        ...payload.headers,
      },
    },
  );
  return data;
};

export const getCmsData = async ({
  pageType,
  pageName,
  policySource,
  groupid,
  collectionType,
  headers,
}: getCmsDataInterface) => {
  const grpId = cookiesManager.get(USER_DATA.GROUP_ID);
  const { data } = await devApiGwXAuthClient.get(
    `${API_ENDPOINTS.cmsData}/${collectionType}`,
    {
      params: {
        pageType,
        pageName,
        groupid,
        ['policy-source']: policySource,
      },
      headers: {
        'x-source': 'vidal',
        'x-groupid': grpId,
        ...headers,
      },
    },
  );
  return data;
};

export const getUserDetails = async (token: string) => {
  const { data } = await devApiGwXAuthClient.get<IUserDetailsResponse>(
    API_ENDPOINTS.userDetails,
    {
      headers: {
        'x-platform': 'web',
        'ocp-apim-subscription-key': import.meta.env.VITE_SUBSCRIPTION_KEY,
        'x-authorization': token,
      },
    },
  );

  return data.data;
};

export const userRoles = async (): Promise<RolesApiData> => {
  const { data } = await devApiGwXAuthClient.get(
    API_ENDPOINTS.userRoles,
    {
      headers: {
        'ocp-apim-subscription-key': import.meta.env.VITE_SUBSCRIPTION_KEY,
      },
    }
  );
  return data.data;
}
